import React from 'react';
import { features } from '../mock';

const Features = () => {
  return (
    <section className="px-6 pb-20">
      <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {features.map((f, i) => (
          <div
            key={f.title}
            className="card-border rounded-2xl bg-[#0e0e14]/60 p-6 transition-all duration-300 hover:-translate-y-1 hover:bg-[#12121a]/80 animate-fade-up"
            style={{ animationDelay: `${i * 90}ms` }}
          >
            <h3 className="gold-text font-semibold text-[15px] mb-2">{f.title}</h3>
            <p className="text-[13px] leading-relaxed text-[#8a8a94]">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
